import { createAction } from 'redux-actions';

export const TYPES = { RATING_SUBMITTED: 'RATING_SUBMITTED' };

export function createNpsSurveyRatingSubmittedAction(submitPromise) {
  return createAction(TYPES.RATING_SUBMITTED)(submitPromise);
}
